import * as React from 'react'
import { EndProgressItemProps } from './typings'

export const RightProgressNode: React.FC<EndProgressItemProps> = (
  props: EndProgressItemProps,
) => {
  const {
    color = '#18325A',
    width = 100,
    radius = 4,
    height = 33,
    transitionTime = 0.5,
  } = props
  const midY: number = Math.ceil(height / 2)

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      enableBackground={`new 0 0 ${width} ${height}`}
      xmlSpace="preserve"
    >
      <path
        style={{ fill: color, transition: `fill ${transitionTime}s` }}
        d={`M${width - radius},${height}c${radius / 2},0,${radius}-${
          radius / 2
        },${radius}-${radius}V${radius}c0-${radius / 2}-${
          radius / 2
        }-${radius}-${radius}-${radius}H-0l${midY},${midY}L-0,${height}H${
          width - radius
        }z`}
      />
    </svg>
  )
}
RightProgressNode.displayName = 'RightProgressNode'
